import { cardsApi } from "../store/api/cardsApi";
import { runMutation, runQuery } from "../store/api/runtime";

export const searchCards = async (params: { game: string; q: string; limit?: number }) =>
  runQuery(cardsApi.endpoints.searchCards.initiate, params);

export const resolveCard = async (payload: { game: string; queryText: string }) =>
  runMutation(cardsApi.endpoints.resolveCard.initiate, payload);

export const getCardMarket = async (params: { game: string; cardId: string }) =>
  runQuery(cardsApi.endpoints.getCardMarket.initiate, params);

export const getCardSoldStats = async (params: { game: string; cardId: string }) =>
  runQuery(cardsApi.endpoints.getCardSoldStats.initiate, params);

export const createCardScanJob = async (payload: FormData) =>
  runMutation(cardsApi.endpoints.createCardScanJob.initiate, payload);

export const getCardScanJob = async (params: { id: string }) =>
  runQuery(cardsApi.endpoints.getCardScanJob.initiate, params, { forceRefetch: true });

export const confirmCardScanJob = async (params: { id: string; payload: Record<string, unknown> }) =>
  runMutation(cardsApi.endpoints.confirmCardScanJob.initiate, params);

export const getCollectionItems = async () =>
  runQuery(cardsApi.endpoints.getCollectionItems.initiate, undefined);

export const saveCollectionItem = async (params: { id: string }) =>
  runMutation(cardsApi.endpoints.saveCollectionItem.initiate, params);

export const saveCollectionItemsBulk = async (params: { ids: string[] }) =>
  runMutation(cardsApi.endpoints.saveCollectionItemsBulk.initiate, params);

export const discardCollectionItemsBulk = async (params: { ids: string[] }) =>
  runMutation(cardsApi.endpoints.discardCollectionItemsBulk.initiate, params);
